import { STORAGE_KEYS } from '../../constants/constants';
import { Account } from '../../models/account';
import { getFeatureFlag } from '../featureFlags/featureFlags';
import { caseInsensitiveCompare } from '../helper';
import { getAccountName } from '../urlHelper';

// Checks if should refetch based on the throttle flag and the last refetched key
// Returns a function that sets the last refetched key in local storage, which
// should be called after the refetch is complete.
// If the URL account name is different than the one in the cache we should always refetch
export const shouldRefetch = (throttleFlag, lastRefetchedKey) => {
    // Check the throttle
    const refetchThrottleMs = +getFeatureFlag<number>(throttleFlag);
    const currentTime = new Date().getTime();
    const lastRefetch = +(localStorage.getItem(lastRefetchedKey) ?? 0);
    const isThrottlePassed = lastRefetch + refetchThrottleMs < currentTime;

    // Check the account name
    // On MSI, getAccountName() returns undefined
    const isAccountNameSame = isUrlAccountSameAsCached();

    // Calculate the refetch condition
    const refetchCondition = isThrottlePassed || !isAccountNameSame;

    // Return the function that sets the last refetched key
    const setLocalStorageLastRefetched = () => localStorage.setItem(lastRefetchedKey, currentTime.toString());

    return {
        refetchCondition,
        setLocalStorageLastRefetched,
    };
};

const isUrlAccountSameAsCached = () => {
    try {
        const currentAccountCache = localStorage.getItem(STORAGE_KEYS.PORTAL_ACCOUNT) ?? '';
        const currentAccount = JSON.parse(currentAccountCache) as Account;
        const cachedAccountName = currentAccount?.organization?.name ?? '';
        const cachedAccountId = currentAccount?.organization?.id ?? '';
        const existsCachedNameOrId = cachedAccountName || cachedAccountId;

        const urlAccountNameOrId = getAccountName() ?? '';

        return existsCachedNameOrId
            && urlAccountNameOrId
            && (
                caseInsensitiveCompare(cachedAccountName, urlAccountNameOrId) || caseInsensitiveCompare(cachedAccountId, urlAccountNameOrId)
            );
    } catch (e) {
        return false;
    }
};
